/* Approved Giulia editorial footer. Moves existing nodes, never clones forms. */
(function () {
  'use strict';
  function compose() {
    var footer = document.querySelector('footer[data-section-type="footer"]');
    var story = document.querySelector('.gs-footer-story');
    if (!footer || !story || footer.dataset.gsEditorial === 'ready') return;
    var page = footer.querySelector('.page-width');
    var grid = page && page.querySelector(':scope > .grid');
    var pillars = story.querySelector('.gs-footer-story__pillars');
    var newsletter = story.querySelector('.gs-footer-story__newsletter');
    var bottom = page && page.querySelector('.site-footer__bottom');
    if (!page || !grid || !pillars || !newsletter || !bottom) return;
    var originalStorySection = story.closest('.shopify-section');
    var heading = story.querySelector('.gs-footer-story__heading');
    if (heading) heading.hidden = true;
    var logo = footer.querySelector('.footer__logo');
    var social = footer.querySelector('.footer__social');
    var logoOwner = logo && logo.closest('.grid__item');
    if (logo) newsletter.prepend(logo);
    var nav = document.createElement('div');
    nav.className = 'gs-footer-editorial__navigation';
    grid.before(nav);
    nav.append(grid);
    if (social) nav.append(social);
    if (logoOwner && !logoOwner.textContent.trim() && !logoOwner.querySelector('a,button,img')) logoOwner.remove();
    var submit = newsletter.querySelector('button[type="submit"]');
    var field = newsletter.querySelector('.gs-footer-story__field');
    if (submit && field) field.after(submit);
    page.prepend(pillars);
    nav.before(story);
    if (originalStorySection && originalStorySection !== footer.closest('.shopify-section') && !originalStorySection.querySelector('.gs-footer-story')) originalStorySection.classList.add('gs-footer-editorial__vacated');
    footer.id = 'GSFooterEditorial';
    footer.dataset.gsEditorial = 'ready';
  }
  compose();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', compose, {once:true});
  document.addEventListener('shopify:section:load', compose);
})();
